// extracted by mini-css-extract-plugin
export default {"wrapper":"Bp-z","response":"Cp-z","error":"Dp-z","disabled":"Ep-z","buttons":"Fp-z","feedbackQuestionSection":"Gp-z","yesNoWrapper":"Hp-z"};